<template>
  <b-form-group
    label="Bağlantı Adresi"
    label-for="url"
  >
    <validation-provider
      #default="{ errors }"
      name="Bağlantı Adresi"
      rules="required"
    >
      <b-form-input
        id="url"
        v-model="dataItem.url"
        placeholder="Bağlantı Adresi"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Url',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['popupImages/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
